// state 定义 + mutations

import { DEFAULT_DAMAGE_INSURANCE_BRIEF } from '@g/utils/damageInsurance'
// brand-fence:start id=kkren-create-tax-whld-state-import brand=kkren predicate=data-driven
import { DEFAULT_TAX_WHLD_METHOD } from '@g/order-shared/taxWhldMethod'
// brand-fence:end id=kkren-create-tax-whld-state-import

export function createInitialViewState () {
  return {
    deliveryMode: '0',
    pendingTransport: '',
    estimateWeight: '',
    useFinalDiscountRate: true,
    damageInsuranceSelections: {},
    damageInsuranceBrief: DEFAULT_DAMAGE_INSURANCE_BRIEF,
    damageInsuranceError: '',
    confirmations: {
      damageInsuranceRisk: false,
      hzkPickup: false,
      x3OverTen: false,
    },
    confirmationErrors: {
      damageInsuranceRisk: false,
      hzkPickup: false,
      x3OverTen: false,
    },
  }
}

export const state = {
  createForm: null,
  createPrepare: null,
  createView: createInitialViewState(),
  couponUsableList: [],
  currAddrInfo: null,
  currTradevanAddr: null,
  isAutoCreate: false,
  declCargoesByFeeType: {},
  declCargoesLoadingKey: '',
}

function sumDeclCargoesTotalAmount (list) {
  return list.reduce((prev, curr) => {
    return prev + Number(curr.totalAmount || 0)
  }, 0)
}

export function normalizeDeclCargoesCache ({ list, error }) {
  const declCargoes = Array.isArray(list) ? list : []
  if (error) {
    return {
      list: declCargoes,
      amount: 0,
      ready: false,
      error,
    }
  }
  return {
    list: declCargoes,
    amount: Math.round(sumDeclCargoesTotalAmount(declCargoes)),
    ready: true,
    error: '',
  }
}

export const mutations = {
  resetCreateViewState (state) {
    state.createView = createInitialViewState()
  },
  setCreateForm (state, createForm) {
    state.createForm = createForm
  },
  setTradevanAddrid (state, tradevanAddrid) {
    if (!state.createForm) return
    state.createForm.tradevanAddrid = tradevanAddrid
  },
  setSrid (state, srid) {
    if (!state.createForm) return
    state.createForm.srid = srid
  },
  setCneeAddrid (state, cneeAddrid) {
    if (!state.createForm) return
    state.createForm.cneeAddrid = cneeAddrid
  },
  setJyoCarrier (state, jyoCarrier) {
    if (!state.createForm) return
    state.createForm.jyoCarrier = jyoCarrier
  },
  setTimeInsuranceSelected (state, value) {
    if (!state.createForm) return
    state.createForm.jyoExtraInfo.isTimeIns = value
  },
  setLossInsuranceAmount (state, amount) {
    if (!state.createForm) return
    state.createForm.jyoExtraInfo.lostInsAmt = amount
  },
  setCreateServiceOption (state, { key, value }) {
    if (!state.createForm || !['isFs', 'isWb', 'isCtn'].includes(key)) return
    state.createForm[key] = value
  },
  setCreatePrepare (state, createPrepare) {
    state.createPrepare = createPrepare
  },
  setCouponUsableList (state, couponUsableList) {
    state.couponUsableList = couponUsableList
  },
  setCouponCrid (state, crid) {
    if (!state.createForm) return
    state.createForm.crid = crid
  },
  setCurrency (state, currency) {
    if (!state.createForm) return
    state.createForm.currency = currency
  },
  setApartPclids (state, apartPclids) {
    if (!state.createForm) return
    state.createForm.jyoExtraInfo.apartPclids = apartPclids
  },
  setIsAutoCreate (state, isAutoCreate) {
    state.isAutoCreate = isAutoCreate
  },
  resetDeclCargoesByFeeType (state) {
    state.declCargoesByFeeType = {}
  },
  setDeclCargoesLoadingKey (state, loadingKey) {
    state.declCargoesLoadingKey = loadingKey
  },
  setDeclCargoesByFeeType (state, payload) {
    if (payload.loadingKey && state.declCargoesLoadingKey && payload.loadingKey !== state.declCargoesLoadingKey) {
      return
    }
    state.declCargoesByFeeType = {
      ...state.declCargoesByFeeType,
      [payload.type]: normalizeDeclCargoesCache(payload),
    }
  },
  setCurrAddrInfo (state, currAddrInfo) {
    if (currAddrInfo?.addrid) {
      try {
        localStorage.setItem(
          'jyorderCreateLastAddr',
          JSON.stringify({
            addrid: currAddrInfo.addrid,
            city: currAddrInfo.city,
          })
        )
      } catch (e) {
        console.error(e)
      }
    }
    state.currAddrInfo = currAddrInfo
  },
  setCurrTradevanAddr (state, currTradevanAddr) {
    if (currTradevanAddr?.addrid) {
      try {
        localStorage.setItem(
          'jyorderCreateLastTradevanAddr',
          JSON.stringify({
            addrid: currTradevanAddr.addrid,
            consignee: currTradevanAddr.consignee,
            idNum: currTradevanAddr.idNum,
            mobile: currTradevanAddr.mobile,
          })
        )
      } catch (e) {
        console.error(e)
      }
    }
    state.currTradevanAddr = currTradevanAddr
  },
  initCreateForm (state, form) {
    state.createView = createInitialViewState()
    state.couponUsableList = []
    state.currAddrInfo = null
    state.currTradevanAddr = null
    state.createForm = {
      pclids: form.pclids,
      currency: '',
      isTwt: '',
      srid: '',
      crid: '', // 優惠券
      cneeAddrid: '',
      tradevanAddrid: '',
      jyoCarrier: '',
      isFs: 0,
      isCtn: 0, // 增加紙箱包裝
      isWs: 0,
      isWb: 0,
      isWx: 0,
      isFcc: 0,
      isOwsu: 0,
      jyoShpMethod: '1',
      useFeeType: 'frt', // notIncTax | frt | tax | busi
      // brand-fence:start id=kkren-create-tax-whld-state-default brand=kkren predicate=data-driven
      jyoExtraFees: {
        taxWhldMethod: DEFAULT_TAX_WHLD_METHOD,
      },
      // brand-fence:end id=kkren-create-tax-whld-state-default
      jyoExtraInfo: {
        apartPclids: [],
        declCargoes: [],
        srInclTax: '0',
        srInclFreq: '0',
        isTimeIns: '0',
        lostInsAmt: 0,
        lostInsRate: 1,
        cargoesValRatio: '0.2', // 0.5 || 1
      },
    }
  },
}
